<template>
    <v-app id="inspire">
        <v-navigation-drawer
            v-if="!loading.data"
            v-model="drawer"
            app
            expand-on-hover
            mini-variant
            :right="$vuetify.rtl">
            <NavDrawerList :groups="navList"/>
        </v-navigation-drawer>
        <v-app-bar
            v-if="!loading.data"
            app
            dense
            elevation="1"
            color="white"
            >
            <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
            <v-toolbar-title>Sales And Distribution</v-toolbar-title>
            <v-spacer></v-spacer>
            <ToolbarMenuRight/>
        </v-app-bar>
        <v-main>
            <v-container :fill-height="checkRouter ? true: false" fluid>
                <v-overlay :value="loading.data" opacity="0" z-index="4">
                    <v-progress-circular
                        indeterminate
                        size="64"
                        color="primary">
                    </v-progress-circular>
                </v-overlay>
                <!-- <home-layout v-if="checkRouter && !loading.data"></home-layout> -->
                <transition name="">
                    <router-view
                        v-if="!loading.data">
                    </router-view>
                </transition>
            </v-container>
        </v-main>
        <RetryDialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit"/>
        <SnackbarAlert
            ref="snackbarAlert"/>
        <v-snackbar :value="snackbar.display" @input="hideSnackbar" :color="snackbar.color" bottom right>{{snackbar.text}}</v-snackbar>

    </v-app>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import moment from 'moment';
import NavDrawerList from './../components/common/NavDrawerList';
import SnackbarAlert from '@/components/common/SnackbarAlert';
import RetryDialog from '@/components/common/RetryDialog';
import ToolbarMenuRight from '@/components/common/ToolbarMenuRight';
import permissions from '../data/permissions';
    export default {
        components: {
            RetryDialog,
            ToolbarMenuRight,
            SnackbarAlert,
            NavDrawerList
        },
        props: {
            source: String,
        },
        data() {
            return {
                drawer: null,
                darkMode: false,
                module: 'sales',
                loading: {
                    data: false
                }
            }
        },
        computed: {
            ...mapGetters({
                snackbar: "ui/snackbar/snackbar"
            }),
            ...mapState('authentication', ["authorizations"]),
            checkRouter() {
                if(this.$route.path == '/sales') return true;
                else return false;
            },
            navList() {
                return [
                    {
                        text: this.$t('pre_sales_activities'),
                        icon: "mdi-folder",
                        items: [
                            {
                                text: this.$t('customers'),
                                icon: "mdi-file-document",
                                to: "/sales/customers",
                                authorization: permissions.customer.read
                            },
                            {
                                text: this.$t('quotations'),
                                icon: "mdi-code-equal",
                                to: "/sales/quotations",
                                authorization: permissions.quotation.read
                            }

                        ]
                    },
                    {
                        text: this.$t('sales_order_processing'),
                        icon: "mdi-folder",
                        items: [
                            {
                                text: this.$t('sales_order_title'),
                                icon: "mdi-file",
                                to: "/sales/blanket-sales-orders",
                                authorization: permissions.sales_order.read
                            },
                            {
                                text: this.$t('pre_scheduling'),
                                icon: "mdi-calendar",
                                to: "/sales/scheduling/report",
                                authorization: permissions.sales_scheduling.read
                            },
                        ]
                    },
                    {
                        text: this.$t('accounts_receivable'),
                        icon: "mdi-folder",
                        items: [
                            {
                                text: this.$t('Payments'),
                                icon: "mdi-credit-card-outline",
                                to: "/sales/payments",
                                authorization: permissions.customer_payment.read
                            },
                            {
                                text: this.$t('invoices'),
                                icon: "mdi-receipt",
                                to: "/sales/invoices",
                                authorization: permissions.sales_invoice.read
                            },
                            {
                                text: this.$t('credit_notes'),
                                icon: 'mdi-ballot-recount',
                                to: '/sales/credit-notes',
                                authorization: permissions.sales_credit_note.read
                            },
                            {
                                text: this.$t('debit_notes'),
                                icon: 'mdi-ballot-recount',
                                to: '/sales/debit-notes',
                                authorization: permissions.sales_debit_note.read
                            }
                        ]
                    },
                    {
                        text: "CRM",
                        icon: "mdi-folder",
                        items: [
                            {
                                text: "Activities",
                                icon: "mdi-phone",
                                to: "/sales/activities",
                                authorization: permissions.customer_activities.read
                            }
                        ]
                    },
                    {
                        text: this.$t('reports'),
                        icon: "mdi-folder",
                        items: [
                            {
                                text: "Dashboard",
                                icon: "mdi-view-dashboard",
                                to: "/sales/dashboard",
                                authorization: permissions.sales_dashboard.all
                            },
                            {
                                text: "Customers Summary",
                                icon: "mdi-poll",
                                to: "/sales/customers-balance-report",
                                authorization: permissions.report.customers_summary //
                            },
                            {
                                text: "Sales By Item Summary",
                                icon: "mdi-poll",
                                to: "/sales/sales-by-item-report",
                                authorization: permissions.report.sales_by_item_summary //
                            },
                            {
                                text: "Sales By Item Details",
                                icon: "mdi-poll",
                                to: "/sales/casting-report",
                                authorization: permissions.report.sales_by_item_details //
                            },
                            {
                                text: "Sales Agreements Summary",
                                icon: "mdi-poll",
                                to: "/sales/sales-orders-report",
                                authorization: permissions.report.sales_agreements_summary //
                            },
                            {
                                text: "Customer Statement",
                                icon: "mdi-poll",
                                to: "/sales/customer-statement",
                                authorization: permissions.report.customer_statement //
                            },
                            {
                                text: "Payments Details",
                                icon: "mdi-poll",
                                to: "/sales/payment-details-report",
                                authorization: permissions.report.customers_payment_details //
                            },
                            {
                                text: this.$t('payment_collection_report'),
                                icon: "mdi-chart-arc",
                                to: "/sales/payment-collection-report",
                                authorization: permissions.report.customers_collection_details //
                            },
                            {
                                text: "Blanket Sales Agreement Validity Report",
                                icon: "mdi-babel",
                                to: "/sales/blanket-sales_agreement-validity-report",
                                authorization: permissions.report.sales_agreement_validity //
                            },
                            {
                                text: "Unearned Revenue",
                                icon: "mdi-poll",
                                to: "/sales/unearned-revenue-report",
                                authorization: permissions.report.unearned_revenue //
                            }
                        ]
                    },
                    {
                        text: this.$t("settings"),
                        icon: "mdi-folder",
                        items: [
                            {
                                text: this.$t('cast_types'),
                                icon: "mdi-cogs",
                                to: "/sales/cast-types",
                                authorization: permissions.cast_type.read
                            },
                            {
                                text: this.$t("branches"),
                                icon: "mdi-map-marker-multiple-outline",
                                to: "/sales/branches",
                                authorization: permissions.sales_branch.index
                            },
                            {
                                text: this.$t("sales_persons"),
                                icon: "mdi-badge-account",
                                to: "/sales/sales-persons",
                                authorization: permissions.sales_person.index
                            }
                        ]
                    }
                ]
            }
        },
        methods: {
            // ...mapActions('warehouse/auth', ["fetchAuthorizations"]),
            ...mapActions('authentication', ['fetchAuthorizations']),
            ...mapActions({
                hideSnackbar: "ui/snackbar/hide"
            }),
            moment,
            async createdDataFetch(){
                try {
                    this.loading.data = true;
                    await this.fetchAuthorizations(this.module);
                    setTimeout(() => {
                        this.loading.data = false;
                    }, 1000);
                } catch(error) {
                    let message = error.response ? error.response.data.message : error;
                    this.$refs.retryDialog.open({target:"createdDataFetch",message});
                }
            },
            openModuleDialog() {
                this.$refs.moduleDialog.open();
            },
            onRetryDialogSubmit(params){
                if(params.target == "createdDataFetch") {
                    if(params.retry) this.createdDataFetch();
                    else this.close()
                }
            },
        },
        created(){
            this.createdDataFetch();
            this.$store.dispatch("sales/item/fetchItems");
            this.$store.dispatch("scheduling/item/fetchItems");
        }
    }
</script>